import stylesPlugin from '@/common/plugins/styles';
import commonLayouts from '@/common/plugins/commonLayouts';

export default {
    install(vue: any) {
        vue.use(stylesPlugin);
        vue.use(commonLayouts);
    },
};
